import { render, staticRenderFns } from "./IssuesNew.vue?vue&type=template&id=33c0fd17&"
import script from "./IssuesNew.vue?vue&type=script&lang=js&"
export * from "./IssuesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports